<template>
  <div class="color-selector-box">
    <div class="data-label">
      color
    </div>
    <div class="color-selector">
      <div
        v-for="(color, index) in colorOptions"
        :id="'hex' + index"
        :key="index"
        class="color-box"
      >
        <div
          :style="colorSquare(color)"
          @click="colorSelected(color, index)"
        />
      </div>
      <div class="color-circle-plus">
        +
      </div>
    </div>
  </div>
</template>

<script>
import { useRMTStore } from '@/store/RMTStore';
import { gsap } from 'gsap';
import { mapStores } from 'pinia';

export default {
	data () {
		return {
			selectedColors: [],
		};
	},
	mounted () {
		if (this.selectedCollectionColor === null) {
			this.selectedColors = [];
			return;
		}
		const startId = '#hex' +
			this.colorOptions.indexOf(this.selectedCollectionColor);
		gsap.to(startId, {
			border: 'black solid 3px',
		});
		this.selectedColors.push(this.selectedCollectionColor);
	},
	computed: {
		...mapStores(useRMTStore),
		colorOptions () {
			return this.RMTStore.colorOptions;
		},
		selectedCollectionColor: {
			get () {
				return this.RMTStore.selectedCollectionColor;
			},
			set (value) {
				this.RMTStore.selectedCollectionColor = value;
			}
		}
	},
	methods: {
		colorSquare (colorHex) {
			return {
				'background-color': colorHex,
				width: '25px',
				height: '25px',
				cursor: 'pointer',
			};
		},
		colorSelected (color, num) {
			const currentId = '#hex' + num;
			if (this.selectedColors.length === 0) {
				this.selectedColors.push(color);
				gsap.to(currentId, {
          duration: .1,
					border: 'black solid 3px',
				});
				this.selectedCollectionColor = color;
			} else {
				if (this.selectedColors.includes(color)) {
					gsap.to(currentId, {
            duration: .1,
						border: 'transparent solid 3px',
					});
					this.selectedColors = [];
					this.selectedCollectionColor = null;
				} else {
					const pastColor = this.selectedColors[0];
          const pastIndex = this.colorOptions.indexOf(pastColor);
					const pastId = '#hex' + pastIndex;
					gsap.to(pastId, {
						border: 'transparent solid 3px',
					});
					this.selectedColors = [];
					gsap.to(currentId, {
            duration: .1,
						border: 'black solid 3px',
					});
					this.selectedColors.push(color);
					this.selectedCollectionColor = color;
					this.RMTStore.colors[pastIndex] = color;
				}
			}
		},
	},
};
</script>

<style scope lang="css">
.color-selector {
	display: flex;
	flex-direction: row;
	align-items: center;

}
.color-box {
	display: flex;
	justify-content: center;
	align-items: center;

  border: transparent solid 3px;
}
.data-label {
	font-size: small;
	width: 17%;
}
.color-circle-plus {
	cursor: pointer;
	font-size: 20px;
	width: 23px;
	height: 23px;
	border-radius: 13px;
	background-color: #c5c5c5;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 3px;
	margin-left: 6px;
}
.color-selector-box {
	display: flex;
	flex-direction: row;
}
</style>
